import {  internal, template, ReactiveElement } from '../vendor/elix.js';

class EmptyReactiveElement extends ReactiveElement {
  get [internal.template]() {
    return template.html``;
  }
}

export default EmptyReactiveElement;
